export default __webpack_public_path__ + "static/media/pdf.6a697650.svg";